// @vue/component
export default {
  name: 'ReportsFormExportItemCheckbox',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: this.currentField.default_value === 'true',
    };
  },
};
